var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentPhone28Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.78575C10 5.74383 10.4139 4.74458 11.1507 4.00783C11.8874 3.27108 12.8866 2.85718 13.9286 2.85718H26.0714C27.1133 2.85718 28.1126 3.27108 28.8493 4.00783C29.5861 4.74458 30 5.74383 30 6.78575V33.2143C30 34.2562 29.5861 35.2555 28.8493 35.9922C28.1126 36.729 27.1133 37.1429 26.0714 37.1429H13.9286C12.8866 37.1429 11.8874 36.729 11.1507 35.9922C10.4139 35.2555 10 34.2562 10 33.2143V6.78575ZM17.5 30C17.2158 30 16.9433 30.1129 16.7424 30.3138C16.5415 30.5148 16.4286 30.7873 16.4286 31.0715C16.4286 31.3556 16.5415 31.6281 16.7424 31.8291C16.9433 32.03 17.2158 32.1429 17.5 32.1429H22.5C22.7842 32.1429 23.0567 32.03 23.2576 31.8291C23.4585 31.6281 23.5714 31.3556 23.5714 31.0715C23.5714 30.7873 23.4585 30.5148 23.2576 30.3138C23.0567 30.1129 22.7842 30 22.5 30H17.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentPhone28Filled);
export default __webpack_public_path__ + "static/media/fluent_phone-28-filled.49716845bb158db04bbd1f0eac50529b.svg";
export { ForwardRef as ReactComponent };